import * as actionTypes from "../actions/actionTypes";

const initialState = {};

const classReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CLASSES:
      return {
        classes: action.payload.classes,
      };

    default:
      return state;
  }
};
export default classReducer;
